module.exports = __webpack_public_path__ + "img/AyudaNewCard.badb9df5.png";